
<div class="content-card filters">
  <div class="top">
    <div class="top__right">
      <button (click)="resetFilters()" class="top__button top__button-clear">
        <mat-icon>close</mat-icon>
        {{ 'Reset' | translate }}
      </button>
      <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
        <mat-icon>filter_alt</mat-icon>
        {{ 'Filter' | translate }}
      </button>
    </div>
  </div>
  @if (areFiltersExpanded) {
    <div #filterSection>
      @if (areFiltersExpanded) {
        <app-absence-list-filters
          [formGroup]="filtersFormGroup"
          (filterGridData)="onFilterDataChange($event)"
        ></app-absence-list-filters>
      }
    </div>
  }
</div>


<app-absence-list [filters]="filters" class="content-card list"></app-absence-list>